export default __webpack_public_path__ + "1c46665ab8af86a989ede985795083d5.png";